
import { mapState } from 'vuex'

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['onCancelTime'],
  computed: {
    ...mapState(['location', 'order', 'errors', 'menu', 'channel']),
    min() {
      if (this.channel === 'catering') {
        // Set minimum to 24 hours from now
        return this.$dayjs().add(24, 'hours').format('YYYY-MM-DD');
      } else {
        // Regular minimum date for non-catering
        return this.$dayjs().format('YYYY-MM-DD');
      }
    },
    max() {
      return this.$dayjs()
        .add(this.location.services.advancedays, 'days')
        .format('YYYY-MM-DD');
    },
    earliest() {
      let earliest = this.$dayjs(this.order.time.earliest)
      if (this.daypart) {
        // get just the date from the earliest available time
        const e_day = earliest.format('YYYYMMDD')
        // get the timestamp for 10:30 on that date
        const e_new = this.$dayjs(`${e_day} 10:30`)
        // compare date @ 10:30 to date @ earliest time
        if (e_new > earliest) {
          // override earliest time with date @ 10:30
          earliest = e_new
        }
      }
      return earliest.format('YYYYMMDD HH:mm')
    },
    times() {
      const times = []
      const increments = [30, 'minutes']
      if (this.date) {
        this.calendar.default.map((d, i) => {
          if (
            this.date ===
            this.$dayjs(d.open, 'YYYYMMDD HH:mm').format('YYYY-MM-DD')
          ) {
            let time = this.$dayjs(d.open, 'YYYYMMDD HH:mm')
            // if we're day parting, start at 10:30
            if (this.daypart) {
              const n_time = `${time.format('YYYYMMDD')}`
              time = this.$dayjs(
                `${time.format('YYYYMMDD')} 10:30`,
                'YYYYMMDD HH:mm'
              )
            }
            const earliest = this.$dayjs(this.earliest, 'YYYYMMDD HH:mm')
            if (time < earliest) {
              // TODO: reset to earliest time
            }
            while (time < this.$dayjs(d.close, 'YYYYMMDD HH:mm')) {
              if (time >= this.$dayjs(this.earliest, 'YYYYMMDD HH:mm')) {
                times.push({
                  value: time.format('HH:mm'),
                  key: time.format('h:mm A')
                })
              }
              time = this.$dayjs(time).add(increments[0], increments[1])
            }
          }
        })
      }
      return times
    },
    selectedTime() {
      return this.order.time.wanted
        ? this.$dayjs(this.order.time.wanted, 'YYYYMMDD HH:mm').format('LLL')
        : null
    },

    shouldShowUpdateButton() {
      // Compare selected date and time with order's current wanted time
      const selectedDateTime = this.$dayjs(`${this.date} ${this.time}`, 'YYYY-MM-DD HH:mm');
      const currentDateTime = this.$dayjs(this.order.time.wanted, 'YYYYMMDD HH:mm');

      return !selectedDateTime.isSame(currentDateTime);
    }
  },
  data() {
    return {
      date: null,
      time: null,
      calendar: null,
      showSelector: this.channel === 'catering' ? false : true,
      asap: true,
      error: '',
      itemsUnavailable: false,
      unavailableProducts: [],
      showUnavailableModal: false,
      showErrorModal: false
    }
  },
  async mounted() {
    this.calendar = await this.$api.getCalendar(
      this.$dayjs().format('YYYYMMDD'),
      this.$dayjs()
        .add(this.location?.services?.advancedays, 'days')
        .format('YYYYMMDD')
    )
    if (this.order.time.mode === 'advance') {
      const wanted = this.$dayjs(this.order.time.wanted, 'YYYYMMDD HH:mm')
      this.date = wanted.format('YYYY-MM-DD')
      this.time = wanted.format('HH:mm')
    } else {
      if (this.channel === 'catering') {
        this.date = this.$dayjs().add(24, 'hours').format('YYYY-MM-DD');
      } else {
        this.date = this.$dayjs(this.earliest).format('YYYY-MM-DD');
      }

      if (!this.time) {
        if (this.channel === 'catering') {
          const minTime = this.$dayjs(this.date).add(24, 'hours').add(15, 'minutes')
          this.time = this.$dayjs(minTime).format('HH:mm');
        } else {
          const minTime = this.$dayjs(this.date).hour(10).minute(30);
          this.time = this.$dayjs(minTime).format('HH:mm');
        }
      }
    }

    // Get unavailable products
    let productIds = []
    let unavailableProducts = []
    this.order.products.forEach(product => {
      productIds.push(product.product_id)
    })
    this.menu.categories.forEach(category => {
      category.products.forEach(product => {
        if (productIds.includes(product.id)) {
          if (!product.availability.now) {
            unavailableProducts.push(product)
          }
        }
      })
    })
    this.unavailableProducts = unavailableProducts
    if (unavailableProducts.length) {
      if (this.order.time.mode == 'asap') {
        this.showUnavailableModal = true
      }
    }
  },
  methods: {
    async setPickupTime() {
      const selectedDateTime = this.$dayjs(`${this.date} ${this.time}`);
      const minAllowedDateTime = this.$dayjs().add(24, 'hours');

      if (this.channel === 'catering' && selectedDateTime.isBefore(minAllowedDateTime)) {
        this.error = 'Error: Catering orders require a minimum of 24 hours in advance.';
        this.$store.commit('setCateringMinTimeOrder', true)
        return;
      } else {
        this.error = '';
        this.$store.commit('setCateringMinTimeOrder', false)
      }

      const time = await this.$api.setTime(`${this.date} ${this.time}`)
      if (time) {
        this.showTimeSelector(false)
        await this.$api.validateOrder()
        this.showErrorModal = true
      } else {
        this.error = 'Error: There was an issue updating your order time. Please double check that the items you\'re ordering are available at the specified time.'
      }
    },
    async setASAP() {
      const time = await this.$api.deleteTime()
      if (time) {
        this.showTimeSelector(false)
      }
      await this.$api.validateOrder()
    },
    showTimeSelector(bool) {
      if (this.channel !== 'catering') {
        this.showSelector = bool
      }
    },

    openDatePicker(event) {
      event.target.showPicker();
    },
    validateDate(event) {
      const selectedDate = this.$dayjs(event.target.value);
      const maxDate = this.$dayjs(this.max);
      const minDate = this.$dayjs(this.min);

      if (!selectedDate.isValid()) {
        return;
      }

      if (selectedDate.isAfter(maxDate)) {
        this.date = this.max;
        this.error = `Error: Please select a date no later than ${maxDate.format('MMM D, YYYY')}`;
        return;
      }

      if (selectedDate.isBefore(minDate)) {
        this.date = this.min;
        this.error = this.channel === 'catering'
          ? 'Error: Catering orders require a minimum of 24 hours in advance'
          : `Please select a date no earlier than ${minDate.format('MMM D, YYYY')}`;
        return;
      }

      this.error = '';
    }
  },
  watch: {
    errors(errors) {
      // Check errors for items that are not available
      errors.forEach(error => {
        if (error.includes('is only available')) {
          this.itemsUnavailable = true
        }
      })
    }
  }
}
